<template>
  <div>
    <div class="page-head">
      <div>
        <el-button type="success" size="small" @click="onCreate">手工录入订单</el-button>
        <el-button type="primary" size="small" @click="onBatchCreate">批量导入订单</el-button>
      </div>
    </div>
    <list row-key="id" ref="list" unit="订单" :page="page" :query-params="params" :show-checkbox="showCheckbox"
      :show-query="showQuery" :get-data-func="getDataFunc" :toolbar-left="16" :toolbar-right="8">
      <div slot="toolbar">
        <div class="toolbar">
          <el-radio-group v-model="params.isPrint" size="mini" @change="onTypeChange" style="margin-right: 10px;">
            <el-radio-button :label="false">未打印（{{ countInfo.noPrint }}）</el-radio-button>
            <el-radio-button :label="true">已打印（{{ countInfo.isPrint }}）</el-radio-button>
          </el-radio-group>
          <el-button type="primary" plain @click="openPrint()">批量打印</el-button>
          <el-button type="primary" plain @click="batchRecycleNumber()">批量回收单号</el-button>
          <el-button type="primary" plain @click="batchDelete()">批量删除</el-button>
          <el-button type="primary" plain @click="onExport">导出订单</el-button>
        </div>
      </div>
      <template slot="query">
        <!-- <el-form-item label="店铺名称">
          <el-select v-model="mallToken" @change="onMallChange" placeholder="请选择">
            <el-option v-for="(i, k) in mallList" :key="k" :label="i.mallName" :value="i.token"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="快递公司">
          <el-select v-model="params.expressName" placeholder="请选择" clearable>
            <el-option v-for="(i, k) in companiesList" :key="k" :label="i.logisticsCompany" :value="i.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="快递单号">
          <el-input v-model="params.expressNumber" placeholder="请输入快递单号" clearable />
        </el-form-item> -->
        <el-form-item label="订单号">
          <el-input v-model="params.orderSn" placeholder="请输入订单号" clearable />
        </el-form-item>
        <el-form-item label="收件人">
          <el-input v-model="params.receiverName" placeholder="请输入收件人" clearable />
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input v-model="params.receiverPhone" placeholder="请输入联系方式" clearable />
        </el-form-item>
        <el-form-item label="订单类型">
          <el-select v-model="params.type" placeholder="请选择" clearable>
            <el-option label="关联订单" :value="10"></el-option>
            <el-option label="手工订单" :value="20"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="地区选择">
          <address-select v-model="params.addressCode" :placeholder="'请选择地区'" @change="onAddressSelect" />
        </el-form-item>
        <el-form-item label="创建时间">
          <range-picker :date="[params.createTimeStart, params.createTimeEnd]"
            @change="x => { params.createTimeStart = x.Start; params.createTimeEnd = x.End; }" />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="orderSn" label="订单号" min-width="280px" />
        <!-- <el-table-column prop="mall.mallName" label="店铺" min-width="220px" /> -->
        <el-table-column prop="type" label="订单类型" width="110px" align="center">
          <template slot-scope="{row}">
            <span v-if="row.type == 10">手工订单</span>
            <span v-if="row.type == 20">关联订单</span>
          </template>
        </el-table-column>
        <el-table-column prop="createdOn" label="创建时间" min-width="180px">
          <template slot-scope="{row}">{{ row.createdOn | long_date }}</template>
        </el-table-column>
        <el-table-column prop="isPrint" label="状态" width="70px" align="center">
          <template slot-scope="{row}">
            <span v-if="row.isPrint == 0">未打印</span>
            <span v-if="row.isPrint == 1">已打印</span>
          </template>
        </el-table-column>
        <el-table-column label="收件信息" min-width="300px" placeholder>
          <template slot-scope="{row}">
            <span>{{ row.receiverName }}，{{ row.receiverPhone }}</span>
            <span>，{{ row.province }}/{{ row.city }}/{{ row.district }}/</span>
            <!-- <span v-if="row.street">{{ row.street }}/</span> -->
            <span>{{ row.address }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="发件人信息" min-width="200px" placeholder>
          <template slot-scope="{row:{senderAddress}}">
            <template v-if="senderAddress">
              <span>{{ senderAddress.fullName }}，{{ senderAddress.mobilePhone }}</span>
              <span>，{{ senderAddress.province }}/{{ senderAddress.city }}/{{ senderAddress.district }}/</span>
              <span v-if="senderAddress.street">{{ senderAddress.street }}/</span>
              <span>{{ senderAddress.detailAddress }}</span>
            </template>
            <template v-else>--</template>
          </template>
        </el-table-column> -->
        <el-table-column label="商品信息" min-width="300px" placeholder>
          <template slot-scope="{row}">{{ row.goodsName }}</template>
        </el-table-column>
        <el-table-column label="商品数量" min-width="100px">
          <template slot-scope="{row}">{{ row.goodsCount }}</template>
        </el-table-column>
        <el-table-column label="重量（kg）" min-width="100px">
          <template slot-scope="{row}">{{ row.goodsWeight }}</template>
        </el-table-column>
        <el-table-column prop="note" label="备注" min-width="300px" placeholder />
        <!-- <el-table-column label="快递信息" min-width="200px">
          <template slot-scope="{row}">
            <template v-if="row.Field8 && row.Field8.length > 0">
              <div v-for="(i1, k1) in row.Field8" :key="k1">
                <div>{{ i1.Field8_1 }}：</div>
                <div v-for="(i2, k2) in i1.Field8_2" :key="k2">{{ i2.Field8_2_1 }}</div>
              </div>
              <div><el-button type="text">复制</el-button></div>
            </template>
            <span v-else>- -</span>
          </template>
        </el-table-column>
        <el-table-column label="单号状态" min-width="120px">
          <template slot-scope="{row}">
            <span v-if="row.Field9 == 0">- -</span>
            <span v-if="row.Field9 == 1">取号失败</span>
            <span v-if="row.Field9 == 2">正常</span>
            <span v-if="row.Field9 == 3">已回收</span>
            <span v-if="row.Field9 == 4">部分回收</span>
          </template>
        </el-table-column> -->
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <print-dialog ref="printDialog" />
    <edit-dialog ref="editDialog" @close-saved="reload" @show-print="showPrint" />
    <batch-insert-dialog ref="batchInsertDialog" @close-saved="reload" />
    <recycle-msg-dialog ref="recycleMsgDialog" @closed="reload" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import batchInsertDialog from "./batchInsertDialog";
import recycleMsgDialog from "./recycleMsgDialog";

export default {
  mixins: [listMixin],
  components: {
    list,
    batchInsertDialog,
    recycleMsgDialog,
    'editDialog': () => {
      return new Promise((resolve, reject) => {
        var sys_type = "ali"; //localStorage.getItem("sys_type");
        console.log("component", sys_type);
        resolve(import('./' + sys_type + '/editDialog'));
      })
    },
    'printDialog': () => {
      return new Promise((resolve, reject) => {
        var sys_type = "ali"; //localStorage.getItem("sys_type");
        console.log("component", sys_type);
        resolve(import('./' + sys_type + '/printDialog'))
      })
    },
  },
  data() {
    return {
      aliApi: {
        order: require("@/api/wx/manualorder").default,
        logistics: require('@/api/wx/logistics').default,
      },
      sysType: "",
      mallToken: "", //店铺Token
      params: {
        isPrint: false,
        type: null,
        expressName: "",
        expressNumber: "",
        orderSn: "",
        receiverName: "",
        receiverPhone: "",
        addressCode: null,
        // createTimeStart: this.$commonJs.getDayAgo(),
        // createTimeEnd: this.$commonJs.getToday(),
        createTimeStart: "",
        createTimeEnd: "",
      },
      companiesList: [],
      mallList: [],
      countInfo: {
        noPrint: 0,
        isPrint: 0,
      }
    };
  },
  created() {
    this.sysType = "ali"; //localStorage.getItem("sys_type");
    // this.mallList = JSON.parse(localStorage.getItem("mall_list"));
    // this.mallToken = localStorage.getItem("token");
    // this.getCompanies();
  },
  mounted() { },
  methods: {
    // onMallChange() {
    //   this.params.expressName = "";
    //   this.companiesList = [];
    //   this.getCompanies();
    // },
    // getCompanies() {
    //   return new Promise((resolve, reject) => {
    //     this[this.sysType + "Api"].logistics.companies(this.mallToken).then(res => {
    //       if (!res.errorCode) this.companiesList = res.data;
    //       resolve(res);
    //     }).catch((err) => { })
    //   })
    // },
    getDataFunc(params) {
      this[this.sysType + "Api"].order.getCountInfo().then(res => {
        if (res) this.countInfo = { ...res }
      })
      params = this.$commonJs.obj.removeNullKey({ ...params, ...this.params })
      console.log("getDataFunc", params)
      return new Promise((resolve, reject) => {
        this[this.sysType + "Api"].order.getManual(params).then(res => {
          console.log("res", res)
          resolve({ code: 0, data: res.data, count: res.count })
        }).catch(err => {
          resolve({ code: 1, data: [] })
        })
      })
    },
    onCreate() {
      this.$refs.editDialog.openCreate().then(that => {
        that.setToken(this.mallToken);
      });
    },
    onBatchCreate() {
      this.$refs.batchInsertDialog.open();
    },
    onTypeChange(e) {
      this.$nextTick(() => {
        this.$refs.list.getData()
      })
    },
    onAddressSelect(e) {
      console.log("111", e);
      // this.data.省市区文本 = e.map(x => x.label).join("/");
      // console.log("222", this.data.省市区);
      // console.log("333", this.data.省市区文本);
    },
    //批量回收单号
    batchRecycleNumber(data = null) {
      let rows = [];
      if (data) {
        rows = [data];
      } else {
        rows = this.$refs.list.getCheckedRows();
        if (rows.length == 0) {
          this.$message.warning("请选择数据");
          return;
        }
      }
      console.log("批量回收单号");
    },
    batchDelete(data = null) {
      let rows = [];
      if (data) {
        rows = [data];
      } else {
        rows = this.$refs.list.getCheckedRows();
        if (rows.length == 0) {
          this.$message.warning("请选择数据");
          return;
        }
      }
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var ids = rows.map(x => x.id);
        console.log("删除", ids);
        this[this.sysType + "Api"].order.delManual({ ids }).then(res => {
          this.$message.success("删除成功")
          this.reload();
        }).catch(err => { })
      }).catch(() => { });
    },
    onEdit(data) {
      this.$refs.editDialog.openEdit(data);
    },
    openPrint(data = null) {
      console.log("open", data)
      let rows = [];
      if (data) {
        rows = [data];
      } else {
        rows = this.$refs.list.getCheckedRows();
        if (rows.length == 0) {
          this.$message.warning("请选择数据");
          return;
        }
      }
      this.$refs.printDialog.open().then(that => {
        that.setData({ state: rows[0].Field5, isPrint: rows[0].isPrint, rows: rows });
      });
    },
    onRecycle(row) {
      var loading = this.$loading({
        lock: true,
        text: "正在回收...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      setTimeout(() => {
        loading.close();
        var data = { success: 3, error: [] }
        if (row.Id == 4) {
          data.error.push({
            no: "463448272394581",
            msg: "更新或取消面单失败，面单已经被揽收、签收、或回收",
          })
          this.$refs.recycleMsgDialog.open().then(that => {
            that.setData(data)
          });
        } else {
          var msg = `共计回收<span style="color: #67C23A;margin: 0 5px;">${data.success}</span>个。`
          this.$alert(msg, '回收成功', {
            confirmButtonText: '确定',
            dangerouslyUseHTMLString: true,
            callback: action => {
              this.reload();
            }
          });
        }
      }, 1000);
    },
    showPrint(id) {
      console.log("showPrint", id)
      this.reload().then(res => {
        this.$refs.printDialog.open().then(that => {
          that.setDataById(id);
        });
      })
    },
    onExport() {
      this.$confirm('是否导出订单？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // console.log("确定")
        this.exportOrders();
      }).catch(() => {
        console.log("取消");
      });
    },
    //订单导出
    exportOrders() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      var params = this.$commonJs.obj.removeNullKey(this.params);
      this[this.sysType + "Api"].order.getManual(params).then(res => {
        if (res && res.data) {
          var list = res.data.map(x => {
            var type = "手工订单";
            if (x.type == 10) type = "手工订单";
            if (x.type == 20) type = "关联订单";
            return {
              orderSn: x.orderSn,
              type: type,
              createdOn: this.$commonJs.toDatetimeString(x.createdOn),
              isPrint: x.isPrint ? '已打印' : '未打印',
              receiver: x.receiverName + "，" + x.receiverPhone + "，" + x.province + x.city + x.district + x.address,
              // province: x.province,
              // city: x.city,
              // district: x.district,
              // address: x.address,
              // receiverName: x.receiverName,
              // receiverPhone: x.receiverPhone,
              goodsName: x.goodsName,
              goodsCount: x.goodsCount,
              goodsWeight: x.goodsWeight,
              note: x.note,
            }
          });
          if (list.length > 0) {
            var item = list[0];
            var keys = Object.keys(item);

            import('@/vendor/Export2Excel').then(excel => {
              const tHeader = ['订单号', '订单类型', '创建时间', '状态', '收件信息', '商品信息', '商品数量', '重量（kg）', '备注'];
              const filterVal = keys;
              excel.export_json_to_excel({
                header: tHeader,
                data: this.formatJson(filterVal, list),
                filename: "导出自定义订单_" + this.$commonJs.toDateStringByFormat(new Date, "YYYYMMDDHHmmss"),
              })
              loading.close();
            })
          } else {
            this.$message.error("没有数据可以导出")
            loading.close();
          }
        } else {
          this.$message.error("获取数据失败")
          loading.close();
        }
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        if (j === 'timestamp') {
          return parseTime(v[j])
        } else {
          return v[j]
        }
      }))
    },
  },
};
</script>
<style lang="scss">
.page-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  border: 1px solid #EBEEF5;
  margin-bottom: 10px;
  padding: 0 5px 0 10px;

  .title {
    margin-right: 20px;
    color: #909399;
    font-size: 14px;
    width: 100px;
  }
}

.time-type {
  display: flex;

  .el-select {
    width: 100px !important;
    margin-right: 10px;

    input {
      width: 100% !important;
    }
  }
}

.toolbar {
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 5px;

  .toolbar-left {
    width: calc(100% - 410px);
    font-size: 14px;
    color: #606266;

    .number {
      margin: 0 10px;
      color: #F56C6C;
    }
  }

  .toolbar-right {
    display: flex;
    width: 410px;
    justify-content: flex-end;
  }
}
</style>